import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { getTeam, getTeamPage } from "./actions";
import Component from "./nationalTeam";
import { selectIsError, selectIsReady, selectTeam } from "./reducer";

const mapStateToProps = createStructuredSelector({
  team: selectTeam,
  isReady: selectIsReady,
  isError: selectIsError,
});

const mapDispatchToProps = (dispatch) => ({
  onGetTeam: (data) => dispatch(getTeam(data)),
  onGetTeamPage: (data) => dispatch(getTeamPage(data)),
});

export function fetchData(store, { match: { url } }) {
  return store.dispatch(getTeamPage({ url }));
}

export default connect(mapStateToProps, mapDispatchToProps)(Component);
